module.exports = __webpack_public_path__ + "img/avatar_erigas.c82ea7f9.png";